import * as $runtime from "../runtime.js";
import * as Algorithm$dNaturalSort from "../Algorithm.NaturalSort/index.js";
import * as Control$dBind from "../Control.Bind/index.js";
import * as Data$dArray from "../Data.Array/index.js";
import * as Data$dEq from "../Data.Eq/index.js";
import * as Data$dFoldable from "../Data.Foldable/index.js";
import * as Data$dFunctor from "../Data.Functor/index.js";
import * as Data$dList from "../Data.List/index.js";
import * as Data$dList$dTypes from "../Data.List.Types/index.js";
import * as Data$dMap$dInternal from "../Data.Map.Internal/index.js";
import * as Data$dMap$dOrdered from "../Data.Map.Ordered/index.js";
import * as Data$dMaybe from "../Data.Maybe/index.js";
import * as Data$dMultiSet from "../Data.MultiSet/index.js";
import * as Data$dOrd from "../Data.Ord/index.js";
import * as Data$dOrderedMultiSet from "../Data.OrderedMultiSet/index.js";
import * as Data$dRecord from "../Data.Record/index.js";
import * as Data$dSet from "../Data.Set/index.js";
import * as Data$dShow from "../Data.Show/index.js";
import * as Data$dString$dCommon from "../Data.String.Common/index.js";
import * as Data$dTuple from "../Data.Tuple/index.js";
import * as Data$dTuple$dT2 from "../Data.Tuple.T2/index.js";
import * as Data$dUnfoldable from "../Data.Unfoldable/index.js";
import * as Restaumatic$dI18n$dTypes from "../Restaumatic.I18n.Types/index.js";
import * as Restaumatic$dMenu$dV2$dParameter from "../Restaumatic.Menu.V2.Parameter/index.js";
import * as Restaumatic$dMenu$dV2$dParametric from "../Restaumatic.Menu.V2.Parametric/index.js";
import * as Restaumatic$dMenu$dV2$dTypes$dInternalParameterChoiceId from "../Restaumatic.Menu.V2.Types.InternalParameterChoiceId/index.js";
import * as Restaumatic$dMenu$dV2$dTypes$dInternalParameterId from "../Restaumatic.Menu.V2.Types.InternalParameterId/index.js";
import * as Restaumatic$dMenu$dV2$dTypes$dParameterChoiceId from "../Restaumatic.Menu.V2.Types.ParameterChoiceId/index.js";
import * as Restaumatic$dMenu$dV2$dTypes$dParameterId from "../Restaumatic.Menu.V2.Types.ParameterId/index.js";
const ProductNode = x => x;
const CategoryNode = x => x;
const ProductCategoryTree = x => x;
const withId = lookup => id => {
  const $0 = Data$dTuple.Tuple(id);
  const $1 = lookup(id);
  if ($1.tag === "Just") { return Data$dMaybe.$Maybe("Just", $0($1._1)); }
  return Data$dMaybe.Nothing;
};
const productsInCategoryCount = v => categoryId => {
  const $0 = Data$dFoldable.find(Data$dFoldable.foldableArray)(v1 => v1.id === categoryId)(v.categories);
  if ($0.tag === "Nothing") { return 0; }
  if ($0.tag === "Just") { return Data$dFoldable.foldlArray(c => v$1 => 1 + c | 0)(0)($0._1.products); }
  $runtime.fail();
};
const modifierItems = modifier => Data$dFoldable.foldableArray.foldMap({
  mempty: Data$dMap$dOrdered.$OMap(Data$dMap$dInternal.Leaf, []),
  Semigroup0: () => ({append: Data$dMap$dOrdered.union(Data$dOrd.ordString)})
})(x => x)(Data$dFunctor.arrayMap(x => x.items)(Data$dRecord.unsafeGet("sections")(modifier)));
const modifierDefaultChoices = modifier => Data$dOrderedMultiSet.fromOccurArray(Data$dEq.eqString)(Data$dFunctor.arrayMap(v => Data$dTuple.$Tuple(
  v._1,
  Data$dRecord.unsafeGet("defaultSelection")(v._2)
))(modifierItems(modifier)._2));
const modifierDefaultChoiceNames = modifier => Data$dArray.filter(v => v._2 > 0)(Data$dFunctor.arrayMap(v => Data$dTuple.$Tuple(
  Data$dRecord.unsafeGet("name")(v._2),
  Data$dRecord.unsafeGet("defaultSelection")(v._2)
))(modifierItems(modifier)._2));
const lookupSection = catalogue => id => Data$dMap$dInternal.lookup(Data$dOrd.ordString)(id)(Data$dRecord.unsafeGet("sections")(catalogue));
const lookupSectionItem = catalogue => menuSectionId => menuSectionItemId => {
  const $0 = Data$dMap$dInternal.lookup(Data$dOrd.ordString)(menuSectionId)(Data$dRecord.unsafeGet("sections")(catalogue));
  if ($0.tag === "Just") {
    const v = Data$dRecord.unsafeGet("content")($0._1);
    if (v.tag === "Products") { return Data$dMap$dInternal.lookup(Data$dOrd.ordString)(menuSectionItemId)(v._1.items._1); }
    return Data$dMaybe.Nothing;
  }
  if ($0.tag === "Nothing") { return Data$dMaybe.Nothing; }
  $runtime.fail();
};
const lookupProductCategory = catalogue => id => Data$dMap$dInternal.lookup(Data$dOrd.ordString)(id)(Data$dRecord.unsafeGet("categories")(catalogue));
const lookupProduct = catalogue => id => Data$dMap$dInternal.lookup(Data$dOrd.ordString)(id)(Data$dRecord.unsafeGet("products")(catalogue));
const productCategoryTree = locale => catalogue => (
  {
    categories: Data$dArray.sortBy((() => {
      const $0 = Data$dOrd.ordArray(Algorithm$dNaturalSort.ordSortChunk);
      return x => y => $0.compare(Algorithm$dNaturalSort.naturalKey(Data$dString$dCommon.toUpper(x.name)))(Algorithm$dNaturalSort.naturalKey(Data$dString$dCommon.toUpper(y.name)));
    })())(Data$dArray.mapMaybe(x => x)(Data$dFunctor.arrayMap(v => {
      const v1 = Data$dMap$dInternal.lookup(Data$dOrd.ordString)(v._1)(Data$dRecord.unsafeGet("categories")(catalogue));
      if (v1.tag === "Nothing") { return Data$dMaybe.Nothing; }
      if (v1.tag === "Just") {
        return Data$dMaybe.$Maybe(
          "Just",
          {
            id: v._1,
            category: v1._1,
            name: Data$dRecord.unsafeGet("name")(v1._1),
            products: Data$dArray.sortBy((() => {
              const $0 = Data$dOrd.ordArray(Algorithm$dNaturalSort.ordSortChunk);
              return x => y => $0.compare(Algorithm$dNaturalSort.naturalKey(Data$dString$dCommon.toUpper(x.translatedName)))(Algorithm$dNaturalSort.naturalKey(Data$dString$dCommon.toUpper(y.translatedName)));
            })())(Data$dArray.mapMaybe(x => x)(Data$dFunctor.arrayMap(productId => {
              const v2 = Data$dMap$dInternal.lookup(Data$dOrd.ordString)(productId)(Data$dRecord.unsafeGet("products")(catalogue));
              if (v2.tag === "Nothing") { return Data$dMaybe.Nothing; }
              if (v2.tag === "Just") {
                return Data$dMaybe.$Maybe(
                  "Just",
                  {id: productId, product: v2._1, translatedName: Restaumatic$dI18n$dTypes.getLocalization(locale)(Data$dRecord.unsafeGet("name")(v2._1))}
                );
              }
              $runtime.fail();
            })(Data$dArray.fromFoldableImpl(Data$dSet.foldableSet.foldr)(v._2))))
          }
        );
      }
      $runtime.fail();
    })(Data$dMap$dInternal.toUnfoldable(Data$dUnfoldable.unfoldableArray)(Data$dMap$dInternal.fromFoldableWith(Data$dOrd.ordString)(Data$dFoldable.foldableArray)(Data$dSet.union(Data$dOrd.ordString))(Data$dFunctor.arrayMap(v => Data$dTuple.$Tuple(
      Data$dRecord.unsafeGet("category")(v._2),
      Data$dMap$dInternal.$$$Map("Two", Data$dMap$dInternal.Leaf, v._1, undefined, Data$dMap$dInternal.Leaf)
    ))(Data$dMap$dInternal.toUnfoldable(Data$dUnfoldable.unfoldableArray)(Data$dRecord.unsafeGet("products")(catalogue))))))))
  }
);
const lookupModifier = catalogue => id => Data$dMap$dInternal.lookup(Data$dOrd.ordString)(id)(Data$dRecord.unsafeGet("modifiers")(catalogue));
const lookupProductBaseItems = catalogue => product => {
  const mapa = Data$dMap$dInternal.filterWithKey(Data$dOrd.ordString)(v => v$1 => Data$dRecord.unsafeGet("displayDefaultItems")(v$1))(Data$dRecord.unsafeGet("modifierSettings")(product));
  const valuesCount = Data$dMap$dInternal.fromFoldable(Data$dOrd.ordString)(Data$dList$dTypes.foldableList)(Data$dList$dTypes.listMap(Data$dTuple$dT2.toTuple)(Data$dList$dTypes.bindList.bind(Data$dList$dTypes.listMap(Data$dFoldable.foldrArray(Data$dList$dTypes.Cons)(Data$dList$dTypes.Nil))(Data$dList.mapMaybe(v => Data$dRecord.unsafeGet("defaultItems")(v))(Data$dMap$dInternal.values(mapa))))(x => x)));
  return Data$dList$dTypes.listMap(v => Data$dRecord.unsafeGet("name")(v))(Data$dMap$dInternal.values(Data$dMap$dInternal.filterWithKey(Data$dOrd.ordString)(x => {
    const $0 = Data$dMap$dInternal.lookup(Data$dOrd.ordString)(x)(valuesCount);
    const $1 = (() => {
      if ($0.tag === "Nothing") { return false; }
      if ($0.tag === "Just") { return $0._1 > 0; }
      $runtime.fail();
    })();
    return v => $1;
  })(Data$dList$dTypes.foldableList.foldMap({
    mempty: Data$dMap$dOrdered.$OMap(Data$dMap$dInternal.Leaf, []),
    Semigroup0: () => ({append: Data$dMap$dOrdered.union(Data$dOrd.ordString)})
  })(x => x)(Data$dList$dTypes.listMap(modifierItems)(Data$dList.mapMaybe(lookupModifier(catalogue))(Data$dSet.foldableSet.foldr(Data$dList$dTypes.Cons)(Data$dList$dTypes.Nil)(Data$dMap$dInternal.functorMap.map(v => {})(mapa)))))._1)));
};
const productDefaultSelection$p = catalogue => product => Data$dMap$dInternal.fromFoldable(Data$dOrd.ordString)(Data$dFoldable.foldableArray)(Data$dFunctor.arrayMap(modifierId => Data$dTuple.$Tuple(
  modifierId,
  Data$dMultiSet.fromOccurArray(Data$dOrd.ordString)((() => {
    const $0 = Data$dMap$dInternal.lookup(Data$dOrd.ordString)(modifierId)(Data$dRecord.unsafeGet("modifiers")(catalogue));
    if ($0.tag === "Just") {
      const $1 = Control$dBind.arrayBind(Data$dRecord.unsafeGet("sections")($0._1))(section => Control$dBind.arrayBind(Data$dRecord.unsafeGet("items")(section)._2)(v => [
        Data$dTuple.$Tuple(v._1, Data$dRecord.unsafeGet("defaultSelection")(v._2))
      ]));
      const $2 = Data$dMap$dInternal.lookup(Data$dOrd.ordString)(modifierId)(Data$dRecord.unsafeGet("modifierSettings")(product));
      const $3 = (() => {
        if ($2.tag === "Just") { return Data$dRecord.unsafeGet("defaultItems")($2._1); }
        if ($2.tag === "Nothing") { return Data$dMaybe.Nothing; }
        $runtime.fail();
      })();
      const $4 = Data$dFunctor.arrayMap(Data$dTuple$dT2.toTuple);
      if ($3.tag === "Just") { return $4($3._1); }
      return $1;
    }
    const $1 = Data$dMap$dInternal.lookup(Data$dOrd.ordString)(modifierId)(Data$dRecord.unsafeGet("modifierSettings")(product));
    const $2 = (() => {
      if ($1.tag === "Just") { return Data$dRecord.unsafeGet("defaultItems")($1._1); }
      if ($1.tag === "Nothing") { return Data$dMaybe.Nothing; }
      $runtime.fail();
    })();
    const $3 = Data$dFunctor.arrayMap(Data$dTuple$dT2.toTuple);
    if ($2.tag === "Just") { return $3($2._1); }
    return [];
  })())
))(Restaumatic$dMenu$dV2$dParameter.allModifiers({catalogue, parametersMemo: {value: Data$dMap$dInternal.Leaf}})(product)));
const lookupMenu = catalogue => id => Data$dMap$dInternal.lookup(Data$dOrd.ordString)(id)(catalogue.menus);
const lookupCustomParameter = catalogue => id => Data$dMap$dInternal.lookup(Data$dOrd.ordString)(id)(Data$dRecord.unsafeGet("customParameters")(catalogue));
const lookupCustomParameterDefaults = catalogue => customParameters => Data$dFoldable.foldlArray(Data$dMap$dInternal.union(Data$dOrd.ordString))(Data$dMap$dInternal.Leaf)(Data$dFunctor.arrayMap(parameterId => {
  const v = Data$dMap$dInternal.lookup(Data$dOrd.ordString)(parameterId)(Data$dRecord.unsafeGet("customParameters")(catalogue));
  if (v.tag === "Just") {
    const $0 = Data$dRecord.unsafeGet("defaultChoice")(v._1);
    if ($0.tag === "Nothing") { return Data$dMap$dInternal.Leaf; }
    if ($0.tag === "Just") { return Data$dMap$dInternal.$$$Map("Two", Data$dMap$dInternal.Leaf, parameterId, $0._1, Data$dMap$dInternal.Leaf); }
    $runtime.fail();
  }
  if (v.tag === "Nothing") { return Data$dMap$dInternal.Leaf; }
  $runtime.fail();
})(customParameters));
const lookupCrossSellingList = catalogue => id => Data$dMap$dInternal.lookup(Data$dOrd.ordString)(id)(Data$dRecord.unsafeGet("crossSellingListsV2")(catalogue));
const lookupCombo = catalogue => id => Data$dMap$dInternal.lookup(Data$dOrd.ordString)(id)(Data$dRecord.unsafeGet("combos")(catalogue));
const lookupAvailabilitySchedule = catalogue => id => Data$dMap$dInternal.lookup(Data$dOrd.ordString)(id)(Data$dRecord.unsafeGet("availabilitySchedules")(catalogue));
const isProductAvailableInFulfillmentMethod = fulfillmentMethod => product => Restaumatic$dMenu$dV2$dParametric.isParametricPossibleBoole.isPossible(Data$dRecord.unsafeGet("variants")(product))(Data$dMap$dInternal.$$$Map(
  "Two",
  Data$dMap$dInternal.Leaf,
  Restaumatic$dMenu$dV2$dTypes$dParameterId.$ParameterId("InternalParameter", Restaumatic$dMenu$dV2$dTypes$dInternalParameterId.FulfillmentMethod),
  Restaumatic$dMenu$dV2$dTypes$dParameterChoiceId.$ParameterChoiceId(
    "InternalParameterChoice",
    Restaumatic$dMenu$dV2$dTypes$dInternalParameterChoiceId.$InternalParameterChoiceId("FulfillmentMethodChoice", fulfillmentMethod)
  ),
  Data$dMap$dInternal.Leaf
));
const displayedProductModifierDefaultChoiceNames = modifier => modifierId => product => {
  const v = Data$dMap$dInternal.lookup(Data$dOrd.ordString)(modifierId)(product.modifierSettings);
  if (v.tag === "Just") {
    if (v._1.displayDefaultItems) {
      if (v._1.defaultItems.tag === "Just") {
        const items = modifierItems(modifier);
        return Data$dArray.mapMaybe(x => x)(Data$dFunctor.arrayMap(v2 => {
          const $0 = Data$dMap$dInternal.lookup(Data$dOrd.ordString)(v2._1)(items._1);
          if ($0.tag === "Just") { return Data$dMaybe.$Maybe("Just", Data$dTuple.$Tuple($0._1.name, v2._2)); }
          return Data$dMaybe.Nothing;
        })(Data$dFunctor.arrayMap(Data$dTuple$dT2.toTuple)(v._1.defaultItems._1)));
      }
      return [];
    }
    return [];
  }
  return [];
};
const productDefaultSelection = catalogue => productId => {
  const $0 = Data$dMap$dInternal.lookup(Data$dOrd.ordString)(productId)(Data$dRecord.unsafeGet("products")(catalogue));
  if ($0.tag === "Just") {
    const $1 = $0._1;
    return Data$dFunctor.arrayMap(v => displayedProductModifierDefaultChoiceNames(v._2)(v._1)($1))(Data$dArray.mapMaybe(x => x)(Data$dFunctor.arrayMap(withId(lookupModifier(catalogue)))(Restaumatic$dMenu$dV2$dParameter.allModifiers({
      catalogue,
      parametersMemo: {value: Data$dMap$dInternal.Leaf}
    })($1))));
  }
  return [];
};
const productDefaultDisplayedSelectionString = locale => catalogue => productId => Data$dString$dCommon.joinWith(", ")(Data$dFunctor.arrayMap(v => {
  const $0 = v._2 > 1;
  const $1 = Data$dShow.showIntImpl(v._2) + " x ";
  return (() => {
    if (!$0) { return ""; }
    if ($0) { return $1; }
    $runtime.fail();
  })() + Restaumatic$dI18n$dTypes.getLocalization(locale)(v._1);
})(Control$dBind.arrayBind(productDefaultSelection(catalogue)(productId))(x => x)));
const customParameterNames = catalogue => Data$dMap$dInternal.functorMap.map(x => x.name)(catalogue.customParameters);
export {
  CategoryNode,
  ProductCategoryTree,
  ProductNode,
  customParameterNames,
  displayedProductModifierDefaultChoiceNames,
  isProductAvailableInFulfillmentMethod,
  lookupAvailabilitySchedule,
  lookupCombo,
  lookupCrossSellingList,
  lookupCustomParameter,
  lookupCustomParameterDefaults,
  lookupMenu,
  lookupModifier,
  lookupProduct,
  lookupProductBaseItems,
  lookupProductCategory,
  lookupSection,
  lookupSectionItem,
  modifierDefaultChoiceNames,
  modifierDefaultChoices,
  modifierItems,
  productCategoryTree,
  productDefaultDisplayedSelectionString,
  productDefaultSelection,
  productDefaultSelection$p,
  productsInCategoryCount,
  withId
};
